let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("hPzOn"), load("lI20R")]).then(() => parcelRequire('7y0yx'));